import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as myGlobals from '../app.component';

@Injectable({
  providedIn: 'root'
})
export class GrievanceServiceService {
  private baseUrl = myGlobals.baseUrl;

  constructor(private http:HttpClient) { }

  createGrievance(data){
    return this.http.post(`${this.baseUrl}/createGrievance`,data);
  }
  getUser() {
    return this.http.post(`${this.baseUrl}/getUser`, null);
  }
  getGrivancesNature(){
    return this.http.get(`${this.baseUrl}/getGrivancesNature`);
  }
  getUsersGrievances(){
    return this.http.get(`${this.baseUrl}/getUsersGrievances`);
  }
}